import React, { useState, useEffect, useContext } from "react";
import { ordenVenta } from "../json/ordenVenta";
import { IoAdd } from "react-icons/io5";
import { CiSearch } from "react-icons/ci";
import "../styles/ordenVenta.css";
import { SelectLimit, Pagination } from "../components";
import { useNavigate } from "react-router-dom";
import { DataContextPaginacion } from "../contex/DataContexPaginacion";

export const OrdenVenta = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const { page, setPage, limit, setLimit, handlePageChange } = useContext(
    DataContextPaginacion,
  );

  /* ------------------- paginacion ----------------------------------*/

  const getElement = (page, limit) => {
    let totalElements = ordenVenta.ordenVenta.length;
    let adjustedLimit = Math.min(limit, totalElements); // Asegura que el límite no exceda el total de elementos
    let start = (page - 1) * adjustedLimit;
    let end = start + adjustedLimit;

    let array = ordenVenta.ordenVenta.slice(start, end);
    setData(array);
  };

  const getLength = () => {
    return ordenVenta.ordenVenta.length;
  };

  let totalPage = Math.ceil(getLength() / limit);

  useEffect(() => {
    getElement(page, limit);
  }, [page, limit]);

  const handleRowClick = (item) => {
    navigate(`/orden-venta/${item.id}`, {
      state: {
        venta: item,
        data: ordenVenta.ordenVenta,
        page,
        limit,
      },
    });
  };
  /*--------------------------------------------------------------------- */

  const getEstadoColor = (estado) => {
    switch (estado) {
      case "CONFIRMADO":
        return { color: "#6da3fc" };
      case "APROBADO":
        return { color: "#89bad0" };
      case "APROBACIÓN PENDIENTE":
        return { color: "#ec762d" };
      case "ANULADO":
        return { color: "#868393" };
      case "BORRADOR":
        return { color: "#96a3a8" };
      case "CERRADO":
        return { color: "#45b98f" };
      default:
        return { color: "#000" };
    }
  };

  const getEstadoPedidoColor = (estadoPedido) => {
    if (estadoPedido.includes("Vence en")) {
      return { color: "#6da3fc" };
    } else if (estadoPedido.includes("Vencido por")) {
      return { color: "#ec762d" };
    } else {
      return { color: "#000" };
    }
  };

  return (
    <div className="ordenVenta_conatiner">
      <div className="ordenVenta_conatiner_h2">
        <h2>Todas las órdenes de venta</h2>
        <div className="ordenVenta_conatiner_btn">
          <button className="ordenVenta_conatiner_btn_nuevo">
            <IoAdd size={24} /> Nuevo
          </button>
          <button className="ordenVenta_conatiner_btn_opcion">
            <span style={{ fontSize: "20px" }}>⋮</span>
          </button>
        </div>
      </div>

      <div className="ordenVenta_conatiner_tabla_wrapper">
        <table className="ordenVenta_conatiner_tabla">
          <thead className="ordenVenta_tabla_title">
            <tr>
              <th>FECHA</th>
              <th>ORDEN DE VENTA N°</th>
              <th>N° DE REFERENCIA</th>
              <th>NOMBRE DE CLIENTE</th>
              <th>ESTADO</th>
              <th>FACTURADA</th>
              <th>PAGO</th>
              <th>IMPORTE</th>
              <th>FECHA DE ENVÍO ESPERADA</th>
              <th>ESTADO DE PEDIDO</th>
              <th>MÉTODO DE ENTREGA</th>
              <th className="ordenVenta_tabla_title_col-2">
                <CiSearch size={24} />
              </th>
            </tr>
          </thead>
          <tbody className="ordenVenta_tabla_title_tbody">
            {data.map((item, index) => (
              <tr
                key={index}
                className="ordenVenta_tabla_fila"
                onClick={() => handleRowClick(item)}
              >
                <td>{item.fecha}</td>
                <td style={{ color: "#6da3fc" }}>{item.orden_de_venta}</td>
                <td>{item.numero_referencia}</td>
                <td>{item.nombre_cliente}</td>
                <td style={getEstadoColor(item.estado)}>{item.estado}</td>
                <td>{item.facturada}</td>
                <td>{item.pago}</td>
                <td>{item.importe}</td>
                <td>
                  {item.fecha_envio_esperada}
                  <br />
                  <span style={getEstadoPedidoColor(item.estado_pedido)}>
                    {item.estado_pedido}
                  </span>
                </td>
                <td style={getEstadoColor(item.estado)}>{item.estado}</td>
                <td>{item.metodo_entrega}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="ordenVenta_pagination-container">
        <div className="ordenVenta_pagination-container-select">
          <SelectLimit onLimitChange={setLimit} setPage={setPage} />
          <Pagination
            totalPage={totalPage}
            page={page}
            limit={limit}
            siblings={1}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};
